import { IAmex, IAmexData, IAmexSessionData } from ".";

export class Amex implements IAmex {
    merchant: string;
    result: string;
    session: IAmexSessionData;
    successIndicator: string;

    constructor(data: IAmexData){
        this.merchant = data.merchant
        this.result = data.result
        this.session = data.session
        this.successIndicator = data.successIndicator
    }
    data(): IAmexData {
        return Object.assign({}, this)
    }
}